/*
 * --------------------------------------------------------------------------- *
 * File: listfield.js                                                          *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React from "react";
import "../App.css";
import { getSampleValue } from "./datatypeutils";
import Field from "./field";

function ListField(props) {
  const onChange = (i, e) => {
    var value = JSON.parse(JSON.stringify(props.value));
    value[i] = e;
    if (props && props.onChange) {
      props.onChange(value);
    }
  };

  const removeElement = (i) => {
    var value = JSON.parse(JSON.stringify(props.value));
    value.splice(i, 1);
    if (props && props.onChange) {
      props.onChange(value);
    }
  };

  try {
    return (
      <div className={props.divCss}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5 className="input-form-subtitle p-2 rounded">{props.title}</h5>
              <hr className="input-form-subtitle border" />
            </div>

            {Array.isArray(props.value) ? (
              props.value.map((v, i) => {
                return (
                  <span key={i} className="field-list-element">
                    <div className="col-12 p-0 m-0 right">
                      <button
                        className="btn btn-sm btn-danger close-button"
                        onClick={(e) => {
                          removeElement(i);
                        }}
                      >
                        X
                      </button>
                    </div>
                    <div className="col-12 p-0 m-0">
                      <Field index={i} type={{ fieldType: props.subType }} value={v} onChange={(e) => onChange(i, e)} />
                    </div>
                  </span>
                );
              })
            ) : (
              <></>
            )}
            <div className="col-12 right mt-2 mb-2">
              <button
                className="btn btn-sm bg-info bg-gradient wide shadow-lg text-white border border-dark"
                onClick={(e) => {
                  onChange(props.value.length, getSampleValue(props.subType));
                }}
              >
                Add {props.title}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  } catch (e) {
    console.log(e);
    return <></>;
  }
}

export default ListField;
